 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }


import AddTeamMemberIntegrationAuthMutation from '../mutations/AddTeamMemberIntegrationAuthMutation'
import CreateOAuth1AuthorizeUrlMutation from '../mutations/CreateOAuth1AuthorizeUrlMutation'
import getOAuthPopupFeatures from './getOAuthPopupFeatures'

class JiraServerClientManager {
  static __initStatic() {this.SCOPES = 'read_api'}
  static openOAuth(
    atmosphere,
    providerId,
    teamId,
    mutationProps
  ) {
    const {submitting, onError, onCompleted, submitMutation} = mutationProps

    // Open synchronously because of Safari
    const popup = window.open(
      '',
      'OAuth',
      getOAuthPopupFeatures({width: 500, height: 750, top: 56})
    )

    const onUrlCompleted = (result) => {
      if (popup) {
        if (!_optionalChain([result, 'access', _ => _.createOAuth1AuthorizeUrl, 'optionalAccess', _2 => _2.url])) {
          onError(_optionalChain([result, 'access', _3 => _3.createOAuth1AuthorizeUrl, 'optionalAccess', _4 => _4.error]))
          popup.close()
          return
        }
        popup.location.href = result.createOAuth1AuthorizeUrl.url
      }
    }

    CreateOAuth1AuthorizeUrlMutation(
      atmosphere,
      {providerId, teamId},
      {onCompleted: onUrlCompleted}
    )

    const handler = (event) => {
      if (typeof event.data !== 'object' || event.origin !== window.location.origin || submitting) {
        return
      }
      const {oauthToken, oauthVerifier} = event.data
      submitMutation()
      AddTeamMemberIntegrationAuthMutation(
        atmosphere,
        {providerId, oauthCodeOrPat: oauthToken, oauthVerifier, teamId},
        {onError, onCompleted}
      )
      popup && popup.close()
      window.removeEventListener('message', handler)
    }
    window.addEventListener('message', handler)
  }
} JiraServerClientManager.__initStatic();

export default JiraServerClientManager
